import request from '@host-panel/request';

export function fetchAuthorizedDomainsRequest(): Promise<any> {
  return request(`/host-panel/authorized-domains`, {
    method: 'GET'
  });
}

export function addAuthorizedDomainRequest(domain: string): Promise<any> {
  return request(`/host-panel/authorized-domains`, {
    method: 'POST',
    data: {
      domain
    }
  });
}

export function removeAuthorizedDomainRequest(domain: string): Promise<any> {
  return request(`/host-panel/authorized-domains`, {
    method: 'DELETE',
    data: {
      domain
    }
  });
}
